import { render } from "./zhi-zing-count.vue?vue&type=template&id=bad704f2&scoped=true"
import script from "./zhi-zing-count.vue?vue&type=script&lang=js"
export * from "./zhi-zing-count.vue?vue&type=script&lang=js"

import "./zhi-zing-count.vue?vue&type=style&index=0&id=bad704f2&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad704f2"]])

export default __exports__